export default __webpack_public_path__ + "static/media/icon-page.74818906.svg";